import { useTranslation } from "react-i18next";
import ElementDocument from "../../types/ElementDocument";
import { Button } from "@shopify/polaris";
import downloadFile from "../../services/DownloadFile";
import IdwalAdobeViewSDKClient from "@idwal/idwal-utilities/lib/IdwalAdobeViewSDKClient/IdwalAdobeViewSDKClient";

interface ReusableDocumentRowProps {
    document: ElementDocument;
}

export const ReusableDocumentRow = ({
    document
}: ReusableDocumentRowProps) => {
    const { t } = useTranslation("common");
    const viewSDKClient = new IdwalAdobeViewSDKClient();

    const previewFile = () => {
        console.info("Preview file");
        viewSDKClient.ready().then(() => {
            viewSDKClient.previewFile(
                process.env.REACT_APP_ADOBE_API_KEY_VALUE,
                document.url,
                document.name,
                document.id,
                {
                    showAnnotationTools: false,
                    showDownloadPDF: false,
                    showPrintPDF: false,
                    embedMode: "LIGHT_BOX"
                }
            );
        });
    }

    const previewIcon = () => {
        return (
            <img
                className="button-icon"
                alt={"preview asset"}
                width="20"
                height="20"
                src="/images/preview_icon.svg"
            />
        );
    }

    const downloadIcon = () => {
        return (
            <img
                className="button-icon"
                alt={"download asset"}
                width="20"
                height="20"
                src="/images/blue-download-icon.svg"
            />
        );
    };

    function onDownload(document: ElementDocument) {
        downloadFile(document.url, document.name);
    }

    return (
        <div id="reusable-element-body" className="reusable-element-body">
            <div id="element-details" className="element-details">
                <img className="file-icon" src="/images/file-icon.svg" alt="file icon" />
                <span id="element-file-name" className="reusable-element-text">{document.name}</span>
            </div>
            <div id="element-controls" className="element-controls">
                <Button
                    onClick={() => previewFile()}
                    icon={previewIcon()}
                    size="large"
                >
                    {t("reuseDocuments.preview")}
                </Button>
                <Button
                    onClick={() => onDownload(document)}
                    icon={downloadIcon()}
                    size="large"
                >
                    {t("reuseDocuments.download")}
                </Button>
            </div>
        </div>
    );
}